export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          关于韩漫
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          致力于打造最优质的免费韩漫在线阅读平台
        </p>

        <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
          <div className="prose prose-sm max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              韩漫平台创立于2024年，是国内领先的<strong>韩漫免费在线观看</strong>网站。我们专注于为中文读者提供最新、最全的韩国漫画资源，涵盖<strong>免费韩漫大全</strong>中的所有热门品类——从甜蜜恋爱到热血奇幻，从悬疑推理到治愈日常，每一部作品都经过精心筛选与专业翻译。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台坚持<strong>韩漫在线免费阅读</strong>理念，所有内容面向用户永久免费开放。我们与韩国多家漫画平台保持紧密合作，确保<strong>韩漫免费看全集漫画</strong>资源每日同步更新，让每一位读者都能第一时间读到最新章节。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们的翻译团队由资深韩语译者和漫画爱好者组成，致力于呈现原汁原味的阅读体验。无论是<strong>韩漫在线看</strong>的流畅度还是<strong>免费韩漫在线</strong>的覆盖面，我们都在不断优化和扩充。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              截至目前，韩漫平台已收录超过5000部作品，累计服务数百万读者。未来我们将继续拓展<strong>韩漫画免费网站</strong>的边界，让更多人享受到<strong>韩漫在线免费阅读</strong>的乐趣。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/70">
            {[
              { num: '5000+', label: '收录作品' },
              { num: '200万+', label: '活跃读者' },
              { num: '30+', label: '合作平台' },
              { num: '99.9%', label: '服务可用率' },
            ].map((item) => (
              <div key={item.label} className="text-center">
                <p className="text-xl md:text-2xl font-heading font-bold text-primary-500">{item.num}</p>
                <p className="text-xs text-foreground-500 mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}